module.exports = __webpack_public_path__ + "img/schedule-service-bar-navy.0ba04340.png";